import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

const TEST_ID = 'Icon-OutboundLink';
export const OutboundLinkIcon = ({ fill = 'gcBlue', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg width={IconSizes[size]} height={IconSizes[size]} viewBox={'0 0 20 20'} data-testid={TEST_ID}>
            <path
                className={fillStyles}
                d="M9.785 2.333V3.5H2.917c-.965 0-1.75.785-1.75 1.75v11.667c0 .964.785 1.75 1.75 1.75h11.666c.965 0 1.75-.786 1.75-1.75v-6.869H17.5v6.869a2.92 2.92 0 0 1-2.917 2.916H2.917A2.92 2.92 0 0 1 0 16.917V5.25a2.92 2.92 0 0 1 2.917-2.917h6.868zM19.834 0v5.25a.584.584 0 0 1-1.167 0V1.992l-8.92 8.921a.586.586 0 0 1-.826 0 .585.585 0 0 1 0-.826l8.921-8.92h-3.258a.584.584 0 0 1 0-1.167h5.25z"
            />
        </svg>
    );
};
OutboundLinkIcon.TEST_ID = TEST_ID;
